export enum HawkerProfileForm {
  EmployeeCorporateCode = 'xlFG',
  AssignCommissionRate = 'BE+1',
  CommissionRateAssignment = '0lCy',
  CommissionRateRules = 'xBVL',
  OperateAllProducts = 'gboF',
  Assign = 'js6J',
  Rate = 'RbY/',
  PrimaryRateRequiredError = 'UNP7',
  PrimaryRate = 'Y29E',
  NoAssignedRate = 'rXCF',
  NoCommissionRate = 'E7NZ',
}
